export const css = {
	oneaction: '_24nu7Zaj',
	' _key': 'ascm-theme/ascm/quiz-widgets/prometric'
};

export default css;
